import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = { class: "dropdown" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-funnel-fill" }, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "btn btn-light-primary",
        type: "button",
        id: "dropdownMenuButton",
        "data-toggle": "dropdown",
        "aria-haspopup": "true",
        "aria-expanded": "false",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showDropDownMenu()))
      }, [
        _createTextVNode(" Filtro "),
        _hoisted_3
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["dropdown-menu dropdown-menu-right", $setup.state.show_drop_down_menu ? 'show-element' : 'not-show-element']),
        "aria-labelledby": "dropdownMenuButton",
        "aria-haspopup": "true",
        "aria-expanded": "false",
        style: {"z-index":"100 !important"}
      }, [
        _createVNode($setup["CustomSearch"], {
          fields: $setup.processedFields,
          clearDependentFields: $props.clearDependentFields,
          onAplicar: $setup.getFilledData,
          title: 'Opções de Filtro',
          onClose: $setup.hideDropDownMenu,
          onSelected: $setup.getSelectedData,
          onCanceled: $setup.getCanceled,
          onCleaned: $setup.getCleaned
        }, null, 8 /* PROPS */, ["fields", "clearDependentFields"])
      ], 2 /* CLASS */)
    ])
  ]))
}